/** Auth utilidades en src **/
export function getTokenFromURL() {
	const urlParams = new URLSearchParams(window.location.search);
	const token = urlParams.get('token');
	return token ? token.trim() : null;
}
export function getCalendarIdFromURL() {
	const urlParams = new URLSearchParams(window.location.search);
	return urlParams.get('calendar') || urlParams.get('c');
}
export async function validateToken(token) {
	if (!token) return false;
	if (token.trim().length < 20) return false;
	return true;
}
export async function getCalendarIdFromToken(token) {
	const cid = getCalendarIdFromURL();
	return cid || 'default-calendar';
}
export function saveToken(token) { localStorage.setItem('lc_token', token); }
export function getSavedToken() { return localStorage.getItem('lc_token'); }
export function clearToken() { localStorage.removeItem('lc_token'); }
export function generateShareLink(calendarId, token) {
	const baseURL = window.location.origin;
	return `${baseURL}/?calendar=${calendarId}&token=${token}`;
}